import React from 'react';
import styled from 'styled-components';

import useMedia from '~hooks/useMedia';

type Props = {
  children: React.ReactNode;
  tooltipText: string;
  position: 'center' | 'right';
  width?: number;
};

function Tooltip({ children, tooltipText, position, width = 282 }: Props) {
  const { isMobile } = useMedia();

  return (
    <TooltipWrapper width={width} position={position} isMobile={isMobile} role='tooltip'>
      {children}
      <span
        className='tooltiptext'
        dangerouslySetInnerHTML={{
          __html: tooltipText,
        }}
      />
    </TooltipWrapper>
  );
}

export default Tooltip;

const TooltipWrapper = styled.div<{ width: number; position: string; isMobile: boolean }>`
  position: relative;
  display: flex;

  ${(props) =>
    props.isMobile &&
    `
    &:after {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 200%;
      height: 200%;
    }
  `}
  & .tooltiptext {
    line-height: 1.5;
    visibility: hidden;
    padding: 15px;
    width: ${(props) => props.width}px;
    background-color: ${(props) => props.theme.colors.magenta700};
    color: ${(props) => props.theme.colors.white100};
    font-size: ${(props) => props.theme.fontSize.C1};
    font-weight: 500;
    text-align: left;
    border-radius: 4px;
    z-index: 1;
    position: absolute;
    top: calc(100% + 12px);
    right: -9px;
    ${(props) => props.position === 'center' && `right: calc(50% - ${props.width / 2 + 2}px);`}

    margin-left: -60px;
    opacity: 0;
    transition: opacity 0.3s;
  }

  & .tooltiptext::after {
    content: '';
    display: block;
    position: absolute;

    ${(props) => props.position === 'center' && 'right : calc(50% - 7px);'}
    ${(props) => props.position === 'right' && 'right: 11px;'}

    bottom: 100%;
    width: 0;
    height: 0;
    border: 7px solid transparent;
    border-bottom-color: ${(props) => props.theme.colors.magenta700};
  }

  &:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
`;
